// Persistent metadata storage for replaced/uploaded local videos that override class recordings.
// This ensures that when a teacher/admin uploads a local video to replace a class recording,
// the uploaded video's exact size, duration, and title are preserved across re-renders,
// refreshes, drawer opens, and modal opens, rather than reverting to stale media-server data
// or m3u8 playlist sizes (~500 bytes).

const STORAGE_PREFIX = 'replacedRecordingMeta';
const EXPIRY_MS = 14 * 24 * 60 * 60 * 1000; // 14 days

export const saveReplacedRecording = ({
  roomName,
  scheduleId,
  fileSize,
  fileDuration,
  fileName,
  durationSec,
  videoDuration,
}) => {
  if (!roomName && !scheduleId) return;

  const validSize = Number(fileSize);
  const meta = {
    fileSize: Number.isFinite(validSize) && validSize > 0 ? validSize : null,
    fileDuration: fileDuration || null,
    fileName: fileName || null,
    durationSec: Number(durationSec) || null,
    videoDuration: Number(videoDuration) || null,
    roomName: roomName || null,
    scheduleId: scheduleId ? String(scheduleId) : null,
    updatedAt: Date.now(),
  };

  try {
    if (roomName) {
      window.localStorage.setItem(`${STORAGE_PREFIX}:room:${roomName}`, JSON.stringify(meta));
    }
    if (scheduleId) {
      window.localStorage.setItem(`${STORAGE_PREFIX}:sched:${scheduleId}`, JSON.stringify(meta));
    }
  } catch (e) {
    console.warn('[recordingStorage] Failed to save replaced recording meta to localStorage', e);
  }
};

export const getReplacedRecording = ({ roomName, scheduleId } = {}) => {
  try {
    let raw = null;
    if (roomName) {
      raw = window.localStorage.getItem(`${STORAGE_PREFIX}:room:${roomName}`);
    }
    if (!raw && scheduleId) {
      raw = window.localStorage.getItem(`${STORAGE_PREFIX}:sched:${scheduleId}`);
    }
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === 'object' && Date.now() - (parsed.updatedAt || 0) < EXPIRY_MS) {
      return parsed;
    }
  } catch (e) {
    console.warn('[recordingStorage] Failed to read replaced recording meta from localStorage', e);
  }
  return null;
};

export const clearReplacedRecording = ({ roomName, scheduleId } = {}) => {
  try {
    if (roomName) {
      window.localStorage.removeItem(`${STORAGE_PREFIX}:room:${roomName}`);
    }
    if (scheduleId) {
      window.localStorage.removeItem(`${STORAGE_PREFIX}:sched:${scheduleId}`);
    }
  } catch (e) {}
};
